import { createTheme } from "@mui/material/styles";

const CustomTextFieldtheme = createTheme({


  components: {
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: "12px",
        },
        outlined: {
          transform: "translate(14px, 14px) scale(1)",
          "&.MuiInputLabel-shrink": {
            transform: "translate(14px, -6px) scale(0.75)",
          },
        },
      },
    },
    MuiOutlinedInput: {
  styleOverrides: {
    root: {
      borderRadius: "7px",
      height: "33px",
      fontSize: "0.8rem",
      display: "flex",
      alignItems: "center",
      backgroundColor: "#fff",

      "&.Mui-focused": {
        backgroundColor: "#fff",
      },

      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "#1976d2", // your primary color
        borderWidth: "1px",
      }
    },

    notchedOutline: {
      transition: "border-color 0.2s ease",
    },

    input: {
      padding: "6px 12px !important",
    }
  }
},
    MuiMenuItem: {
      styleOverrides: {
        root: {
          // Default font size, will be overridden dynamically
          fontSize: "0.8rem", // Default size for normal input
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          fontSize: "0.8rem",
          "&.MuiFormHelperText-sizeSmall": {
            fontSize: "0.6rem",
    
          },
          "&.MuiFormHelperText-sizeNormal": {
            fontSize: "0.7rem",
            color:"red"
          },
          "&.MuiFormHelperText-sizeMedium": {
            fontSize: "0.8rem",
          },
          "&.MuiFormHelperText-sizeLarge": {
            fontSize: "1rem",
          },
        },
      },
    },
    
  },
  overrides: {
    MuiMenuItem: {
      root: {
        "&.MuiInputBase-sizeSmall": {
          fontSize: "0.6rem", // Font size for small input
        },
        "&.MuiInputBase-sizeNormal": {
          fontSize: "0.8rem", // Font size for normal input
        },
        "&.MuiInputBase-sizeMedium": {
          fontSize: "0.8rem", // Font size for medium input
        },
        "&.MuiInputBase-sizeLarge": {
          fontSize: "1rem", // Font size for large input
        },
      },
    },
  },
});

export default CustomTextFieldtheme;
